<div class="is-flex is-column gap-24">
  <ng-container *ngFor="let room of rooms$ | async; trackBy: trackById">
    <app-cp-compare-sidebar-room [room]="room"></app-cp-compare-sidebar-room>
  </ng-container>
</div>
